module.exports = __webpack_public_path__ + "vrplayerstatic/media/loader.b2cda74b.svg";